import missionImage1 from '../images/instragram/11.jpg';
import missionImage2 from '../images/instragram/12.jpg';
import missionImage3 from '../images/instragram/13.jpg';
import missionImage4 from '../images/instragram/14.jpg';
import missionImage5 from '../images/instragram/15.jpg';
import missionImage6 from '../images/instragram/16.jpg';
import missionImage7 from '../images/instragram/17.jpg';
import missionImage8 from '../images/instragram/14.jpg';
import missionImage9 from '../images/instragram/15.jpg';
import missionImage10 from '../images/causes/1.jpg';

import missionImage11 from '../images/instragram/18.jpg';
import missionImage12 from '../images/instragram/19.jpg';
import missionImage13 from '../images/instragram/20.jpg';
import missionImage14 from '../images/instragram/21.jpg';
import missionImage15 from '../images/instragram/22.jpg';
import missionImage16 from '../images/instragram/23.jpg';
import missionImage17 from '../images/instragram/24.jpg';
import missionImage18 from '../images/instragram/25.jpg';


import missionImage19 from '../images/instragram/26.jpg';
import missionImage20 from '../images/instragram/27.jpg';
import missionImage21 from '../images/instragram/28.jpg';
import missionImage22 from '../images/instragram/29.png';
import missionImage23 from '../images/instragram/30.png';
import missionImage24 from '../images/instragram/31.png';

import missionImage25 from '../images/instragram/29.jpg';
import missionImage26 from '../images/instragram/31.jpg';
import missionImage27 from '../images/instragram/32.jpg';
import missionImage28 from '../images/instragram/33.jpg';
import missionImage29 from '../images/instragram/34.jpg';
import missionImage30 from '../images/instragram/35.jpg';
import missionImage31 from '../images/instragram/36.jpg';

import missionImage32 from '../images/instragram/37.jpg';
import missionImage33 from '../images/instragram/38.jpg';
import missionImage34 from '../images/instragram/39.jpg';
import missionImage35 from '../images/instragram/40.jpg';
import missionImage36 from '../images/instragram/41.jpg';
import missionImage37 from '../images/instragram/42.jpg';
import missionImage38 from '../images/instragram/43.jpg';

import missionImage39 from '../images/instragram/45.jpg';
import missionImage40 from '../images/instragram/46.jpg';
import missionImage41 from '../images/instragram/47.jpg';
import missionImage42 from '../images/instragram/48.jpg';
import missionImage43 from '../images/instragram/49.jpg';
import missionImage44 from '../images/instragram/50.jpg';

import missionImage45 from '../images/instragram/51.jpg';
import missionImage46 from '../images/instragram/52.jpg';
import missionImage47 from '../images/instragram/53.jpg';
import missionImage48 from '../images/instragram/54.jpg';
import missionImage49 from '../images/instragram/55.jpg';
import missionImage50 from '../images/instragram/56.jpg';
import missionImage51 from '../images/instragram/57.jpg';
import missionImage52 from '../images/instragram/58.jpg';
import missionImage53 from '../images/instragram/59.jpg';
import missionImage54 from '../images/instragram/60.jpg';

import missionImage55 from '../images/instragram/61.jpg';
import missionImage56 from '../images/instragram/62.jpg';
import missionImage57 from '../images/instragram/63.jpg';
import missionImage58 from '../images/instragram/64.jpg';
import missionImage59 from '../images/instragram/65.jpg';
import missionImage60 from '../images/instragram/66.jpg';
import missionImage61 from '../images/instragram/67.jpg';
import missionImage62 from '../images/instragram/68.jpg';
import missionImage63 from '../images/instragram/69.jpg';

import missionImage64 from '../images/instragram/72.jpg';
import missionImage65 from '../images/instragram/73.jpg';
import missionImage66 from '../images/instragram/74.jpg';
import missionImage67 from '../images/instragram/75.jpg';
import missionImage68 from '../images/instragram/76.jpg';
import missionImage69 from '../images/instragram/77.jpg';
import missionImage70 from '../images/instragram/78.jpg';

import missionImage71 from '../images/instragram/79.png';
import missionImage72 from '../images/instragram/80.png';
import missionImage73 from '../images/instragram/81.png';
import missionImage74 from '../images/instragram/82.png';
import missionImage75 from '../images/instragram/83.png';
import missionImage76 from '../images/instragram/84.png';
import missionImage77 from '../images/instragram/85.png';

const missions = [
  {
    id: 1,
    slug: 'new-year-2024',
    title: 'The Inaugural New Year Campaign',
    year: 2024,
    location: 'Addis Ababa',
    image: missionImage63,
    description: 'The 2017 E.C. New Year Campaign marked the very first major humanitarian milestone for our hospital. Launched under the principle "Let’s Save Children from Heart Disease Together," this inaugural initiative successfully provided life-saving care to vulnerable children, ensuring they could start the new year with a healthy heart.',
    highlights: [
      '32 Lives Restored',
      'Collaborative Community Support',
      'Profound Medical Recovery'
    ],
    stats: {
      childrenTreated: 45,
      volunteers: 12,
      duration: 'Annual Impact'
    },
    fullDescription: `
This first-ever New Year campaign, led by Ato Berhanu Tedla, established our commitment to making specialized cardiac care accessible within Ethiopia. By bridging the gap between advanced technology and financial need, we transformed our first year into a period of hope for families who previously had no local options for free heart surgery. 

      Key achievements included:
      1. 32 Lives Restored: Our first major achievement in pediatric cardiac surgery.
      2. Collaborative Support: Activating community and donor support for the very first time.
      3. Local Medical Victory: Proving that complex heart surgeries can be performed successfully right here at home.

    `,
    gallery: [
      missionImage20,
      missionImage19,
      missionImage21,
      missionImage22,
      missionImage23,
      missionImage24,
      missionImage7,
      missionImage8,
     
    ],
    
    team: [
      { name: 'Dr. Sarah Johnson', role: 'Lead Surgeon' },
      { name: 'Dr. Michael Chen', role: 'Pediatric Cardiologist' },
      { name: 'Nurse Emma Davis', role: 'Head Nurse' }
    ]
  },
  {
    id: 2,
    slug: 'campaign-jigjiga',
    title: 'Campaign Ethio-Istanbul General Hospital & Italy specialists',
    year: 2026,
    location: 'Jigjiga',
    image: missionImage7,
    description: 'This mission focuses on bringing life-saving cardiac care directly to the Somali Regional State through a historic medical partnership. By establishing a specialized surgical hub at Sheik Hassen Yebere Referral Hospital, complex, high-precision heart surgeries were successfully delivered through the joint collaboration of Ethio-Istanbul General Hospital’s medical team and the Italian medical team. Together, this unified team provided free, life-saving procedures for 16 children in the region, ensuring that distance is no longer a barrier to quality, world-class healthcare.                                                                                                                                                                                                ',
    highlights: [
      '16  Health Professionals',
      '7 Life-Saving Surgeries',
      '4-Day Intensive Campaign '
    ],
    stats: {
      childrenTreated: 32,
      volunteers: 8,
      duration: '4 days'
    },
    fullDescription: `
Mission Overview
    This mission focuses on bringing life-saving cardiac care directly to the Somali Regional State through a historic partnership between the Italian medical team and Ethio-Istanbul  General Hospital. By establishing a specialized surgical hub in the region, we are providing free, high-precision heart surgeries, ensuring that distance is no longer a barrier to quality healthcare.
        Key Highlights
          1. Joint Specialist Team: A collaborative medical mission powered by Italian specialists and Ethio-Istanbul General Hospital.
          2. 16 Life-Saving Surgeries: Successful high-precision heart procedures performed for children in the Somali Region during this mission.
          3.Jijiga 2026: A high-impact 4-day surgical window dedicated to regional healthcare expansion.

    `,
     gallery: [
      missionImage1,
      missionImage2,
      missionImage3,
      missionImage4,
      missionImage5,
      missionImage6,
      missionImage7,
      missionImage8,
     
    ],
    instagram:[
      missionImage11,
      missionImage12,
      missionImage13,
      missionImage14,
      missionImage15,
      missionImage16,
      missionImage17,
      missionImage18,

    ],
    team: [
      { name: 'Dr. James Wilson', role: 'Medical Director' },
      { name: 'Dr. Lisa Park', role: 'Cardiac Surgeon' },
      { name: 'Coordinator Tom Brown', role: 'Program Coordinator' }
    ]
  },
   {
    id: 3,
    slug: 'new-year-2025',
    title: 'The 2018 E.C. New Year Campaign ',
    year: 2025,
    location: 'Addis Ababa',
    image: missionImage31,
    description: "This milestone marks our second year of operation and a deepened commitment to Ethiopia's children. In the prestigious presence of former President H.E. Dr. Mulatu Teshome, we officially launched a special initiative to provide 10 additional free heart surgeries for vulnerable families. By bridging the gap between advanced medical technology and those in financial need, we are ensuring that life-saving cardiac care is a right, not a privilege, accessible right here at home.",
    highlights: [
      'Comprehensive pre-operative screening for children in need',
      'Medical training for local surgical teams',
      'Family support and follow-up care after discharge'
    ],
    stats: {
      childrenTreated: 45,
      volunteers: 12,
      duration: 'Annual Impact '
    },
    fullDescription: `
      The 2018 E.C.New Year Gift Campaign marks a historic milestone in our second year of operation. In the presence of former President H.E. Dr. Mulatu Teshome, we officially launched a special initiative to provide 10 additional free heart surgeries for children from vulnerable families. Our mission is to bridge the gap between advanced medical technology and financial need, ensuring that life-saving cardiac care is a right, not a privilege, accessible to every family right here in Ethiopia.

      The mission focused on three key areas:
      1. A New Year Gift: Providing 10 life-saving surgeries for vulnerable children.
      2. Expanding Impact: Over 52 million Birr in free care delivered to date.
      3. Local Excellence: Providing world-class cardiac solutions within Ethiopia.

      Through this initiative, we not only saved lives but also created sustainable healthcare infrastructure that will continue to serve Zambian children for years to come.
    `,
    gallery: [
      missionImage25,
      missionImage27,
      missionImage26,
      missionImage28,
      missionImage29,
      missionImage30,
      missionImage7,
      missionImage8,
      missionImage9
    ],
      instagram:[
      missionImage32,
      missionImage33,
      missionImage34,
      missionImage35,
      missionImage36,
      missionImage37,
      missionImage38,

    ],
    team: [
      { name: 'Dr. Sarah Johnson', role: 'Lead Surgeon' },
      { name: 'Dr. Michael Chen', role: 'Pediatric Cardiologist' },
      { name: 'Nurse Emma Davis', role: 'Head Nurse' }
    ]
  },
  {
    id: 4,
    slug: 'ethio-istanbul-campaign',
    title: 'Campaign Ethio-Istanbul Hospital',
    year: 2026,
    location: 'Addis Ababa',
    image: missionImage62,
    description: "This mission focuses on eliminating the pediatric cardiac backlog through a historic partnership. By utilizing Ethio-Istanbul General Hospital as a specialized hub, life-saving, high-precision heart surgeries are delivered through a collaboration between the hospital's clinical team and volunteer Italian specialists. Supported by Heart to Heart’s logistics and financial aid, children receive world-class care entirely free of charge. ",
    highlights: [
      '80 Life-Saving Surgeries',
      'Joint Specialist Team',
      '45-Day Intensive Campaign '
    ],
    stats: {
      childrenTreated: 45,
      volunteers: 12,
      duration: '45 Days'
    },
    fullDescription: `
      The Ethio-Istanbul 2026 medical campaign represents a historic milestone in our efforts to reduce the high backlog of pediatric cardiac cases in Ethiopia. This mission was powered by a collaborative partnership between the international specialists from Italy (Pedre Payo team) and our dedicated Ethiopian medical professionals. Together, we established a high-standard surgical model that brought world-class heart care directly to our patients.

      Key Campaign Achievements:      
      1. Joint Surgical Excellence: A historic collaboration between Italian specialists and Ethio-Istanbul General Hospital to perform high-precision heart procedures.
      2. High-Impact 45-Day Campaign: An intensive surgical window dedicated to providing immediate, life-saving interventions for children in urgent need.
      3. 80 Successful Outcomes: The combined medical team successfully completed heart surgeries for 80 children at Ethio-Istanbul General Hospital in Addis Ababa.
      `,
    gallery: [
      missionImage55,
      missionImage57,
      missionImage56,
      missionImage58,
      missionImage59,
      missionImage60,
      missionImage61,
  
    ],
      
    team: [
      { name: 'Dr. Sarah Johnson', role: 'Lead Surgeon' },
      { name: 'Dr. Michael Chen', role: 'Pediatric Cardiologist' },
      { name: 'Nurse Emma Davis', role: 'Head Nurse' }
    ]
  },
  {
    id: 5,
    slug: 'campaign-ethio-istanbul-italy',
    title: 'Campaign Ethio-Istanbul General Hospital with Italy specialists',
    year: 2026,
    location: 'Jijiga',
    image: missionImage54,
    description: "This mission focuses on bringing life-saving cardiac care directly to the Somali Regional State through a partnership between Italian specialists and Ethio-Istanbul  General Hospital. By establishing a specialized surgical hub at Sheik Hassen Yebere Hospital, we provided free, high-precision heart surgeries for 16 children in the region, ensuring that distance is no longer a barrier to quality healthcare.",
    highlights: [
      '16 Lives Saved',
      'Joint Expertise',
      '4-Day Intensive Campaign '
    ],
    stats: {
      childrenTreated: 45,
      volunteers: 12,
      duration: '4 Days'
    },
    fullDescription: `
This mission focuses on bringing life-saving cardiac care directly to the Somali Regional State through a historic partnership between the Italian medical team and Ethio-Istanbul General Hospital. By establishing a specialized surgical hub in the region, we are providing free, high-precision heart surgeries, ensuring that distance is no longer a barrier to quality healthcare.

      Key Highlights:
      1.Joint Specialist Team: A collaborative medical mission powered by Italian specialists and Ethio-Istanbul General Hospital.
      2. 16 Life-Saving Surgeries: Successful high-precision heart procedures performed for children in the Somali Region during this mission.
      3. Jijiga 2026: A high-impact 4-day surgical window dedicated to regional healthcare expansion.
    `,
     gallery: [
      missionImage41,
      missionImage42,
      missionImage39,
      missionImage40,
      missionImage43,
      missionImage44,
    
    ],
      instagram:[
      missionImage45,
      missionImage46,
      missionImage47,
      missionImage51,
      missionImage52,
      missionImage53,
      missionImage50,
      missionImage49,
      missionImage48,

    ],
    team: [
      { name: 'Dr. Sarah Johnson', role: 'Lead Surgeon' },
      { name: 'Dr. Michael Chen', role: 'Pediatric Cardiologist' },
      { name: 'Nurse Emma Davis', role: 'Head Nurse' }
    ]
  },
   {
    id: 6,
    slug: 'campaign-gondar',
    title: 'Campaign Gondar University Hospital',
    year: 2026,
    location: 'Gondar',
    image: missionImage77,
    description: "This mission focuses on eliminating the backlog of pediatric cardiac cases through a historic medical partnership. The complex, high-precision heart surgeries were successfully delivered through a powerful collaboration between Gondar University Hospital, Ethio-Istanbul General Hospital's medical team, and visiting Italian specialists, who pooled their expertise and clinical resources to save children's lives. Supporting this vital joint effort, Heart to Heart served as the core enabler by fully managing the logistics and providing the necessary financial aid ensuring that every child received world-class care entirely free of charge. ",
    highlights: [
      '23 Life-Saving Surgeries',
      'Joint Expertise',
      '4-Day Intensive Campaign'
    ],
    stats: {
      childrenTreated: 45,
      volunteers: 12,
      duration: '4 Days'
    },
    fullDescription: `
    Mission Overview
The Gondar University 2026 medical campaign represents a historic milestone in the efforts to reduce the high backlog of pediatric cardiac cases in Ethiopia. This mission was powered by a collaborative partnership between the international specialists from Italy (Padre Pio team) and Ethio-Istanbul General Hospital. Together, this joint team established a high-standard surgical model that utilized Gondar University's facilities to bring world-class heart care directly to patients. 
      Key Campaign Achievements:
        1. Joint Surgical Excellence: A historic collaboration between Italian specialists, Ethio-Istanbul General Hospital, and Gondar University Hospital doctors to perform high-precision heart procedures. 
        2. High-Impact 4-Day Campaign: An intensive surgical window dedicated to providing immediate, life-saving interventions for children in urgent need.
        3. 23 Successful Outcomes: The combined medical team successfully completed heart surgeries for 23 children at Gondar University General Specialized Hospital.

    `,
     gallery: [
      missionImage71,
      missionImage72,
      missionImage73,
      missionImage74,
      missionImage75,
      missionImage76,
    
    ],
     
    team: [
      { name: 'Dr. Sarah Johnson', role: 'Lead Surgeon' },
      { name: 'Dr. Michael Chen', role: 'Pediatric Cardiologist' },
      { name: 'Nurse Emma Davis', role: 'Head Nurse' }
    ]
  },
     {
    id: 7,
    slug: 'campaign-jimma',
    title: 'Campaign Jimma University Medical Center',
    year: 2026,
    location: 'Jimma',
    image:missionImage70,
    description: "This mission focuses on eliminating the backlog of pediatric cardiac cases through a historic partnership. By utilizing Jimma University Medical Center as the specialized clinical space and venue, the entire medical treatment and high-precision heart surgeries were delivered by Ethio-Istanbul General Hospital. Supporting this collaborative effort, Heart to Heart acted as the vital enabler by managing the logistics and providing the necessary financial aid ensuring these 13 children received free, exceptional care and giving every child the opportunity to grow, thrive, and live a healthy life. ",
    highlights: [
      '13 Life-Saving Surgeries',
      'Joint Expertise',
      '4-Day Intensive Campaign'
    ],
    stats: {
      childrenTreated: 45,
      volunteers: 12,
      duration: '4 Days'
    },
    fullDescription: `
The Jimma University 2026 medical campaign represents a historic milestone in the efforts to reduce the high backlog of pediatric cardiac cases in Ethiopia. This mission was powered by a collaborative partnership between the dedicated clinical team at Ethio-Istanbul General Hospital and local medical professionals. By utilizing Jimma University Medical Center’s clinical space as the operational venue, this joint initiative established a high-standard surgical model that brought world-class heart care directly to patients in need. 

      Key Campaign Achievements:
          1. Joint Surgical Excellence:A historic collaboration between the Ethio-Istanbul General Hospital clinical team and Jimma University Medical Center doctors to perform high-precision heart procedures. 
          2. High-Impact 4-Day Campaign: An intensive surgical window dedicated to providing immediate, life-saving interventions for children in urgent need.
          3. 13 Successful Outcomes: The combined medical team successfully completed heart surgeries for 13 children at Jimma University Medical Center from May 20 to 23.

    `,
     gallery: [
      missionImage64,
      missionImage69,
      missionImage65,
      missionImage67,
      missionImage68,
      missionImage66,
    
    ],
      
    team: [
      { name: 'Dr. Sarah Johnson', role: 'Lead Surgeon' },
      { name: 'Dr. Michael Chen', role: 'Pediatric Cardiologist' },
      { name: 'Nurse Emma Davis', role: 'Head Nurse' }
    ]
  },

       {
    id: 8,
    slug: 'campaign-tikur-anbessa',
    title: 'Campaign Jimma University Medical Center',
    year: 2026,
    location: 'Jimma',
    image: missionImage54,
    description: "This mission focuses on eliminating the backlog of pediatric cardiac cases through a historic partnership between Italian specialists and our medical team. By utilizing Jimma University Medical Center as a specialized cardiac hub, we are providing free, high-precision heart surgeries for children, ensuring world-class care is accessible within our facility.",
    highlights: [
      '13 Life-Saving Surgeries',
      'Joint Expertise',
      '4-Day Intensive Campaign'
    ],
    stats: {
      childrenTreated: 45,
      volunteers: 12,
      duration: '4 Days'
    },
    fullDescription: `
The Jimma University 2026 medical campaign represents a historic milestone in our efforts to reduce the high backlog of pediatric cardiac cases in Ethiopia. This mission was powered by a collaborative partnership between the international specialists from Italy (Padre Pio team) and our dedicated Ethiopian medical professionals. Together, we established a high-standard surgical model that brought world-class heart care directly to our patients.

      Key Mission Achievements:
     1. Joint Surgical Excellence: A historic collaboration between Italian specialists and Jimma University Medical Center doctors to perform high-precision heart procedures.
     2. High-Impact 4-Day Campaign: An intensive surgical window dedicated to providing immediate, life-saving interventions for children in urgent need.
     3. 13 Successful Outcomes: The combined medical team successfully completed heart surgeries for 13 children at Jimma University Medical Center from May 20 to 23.
    `,
     gallery: [
      missionImage41,
      missionImage42,
      missionImage39,
      missionImage40,
      missionImage43,
      missionImage44,
    
    ],
      instagram:[
      missionImage45,
      missionImage46,
      missionImage47,
      missionImage51,
      missionImage52,
      missionImage53,
      missionImage50,
      missionImage49,
      missionImage48,

    ],
    team: [
      { name: 'Dr. Sarah Johnson', role: 'Lead Surgeon' },
      { name: 'Dr. Michael Chen', role: 'Pediatric Cardiologist' },
      { name: 'Nurse Emma Davis', role: 'Head Nurse' }
    ]
  },
];

export default missions;